export default "__VITE_ASSET__MDzOGkow__"